import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { WeeklyResultByStoreReportService } from '../../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { YtdResultByStoreService } from '../ytd-result-by-store.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';

@Component({
  selector: 'app-ytd-result-by-store-view',
  standalone: false,
  templateUrl: './ytd-result-by-store-view.component.html',
  styleUrl: './ytd-result-by-store-view.component.scss'
})
export class YtdResultByStoreViewComponent {

  reportData: any[] = [];
  requestData: any = null;
  totals: any = {};
  IsDownloading: boolean = false;
  labourDetails: any = {};
  isLoading: boolean = false;



  displayedColumns: string[] = [
    'shop_name',
    'this_year_this_week_sales',
    'last_year_this_week_sales',
    'sales_var',
    'sales_var_percent',
    'this_week_cust_orders',
    'last_year_cust_orders',
    'orders_var',
    'orders_var_percent',
    'avg_sale_ty',
    'avg_sale_ly',
    'labour_percent_ty',
    'labour_percent_ly',
    'labour_percent_var'
  ];


  groupHeaderColumns: string[] = ['shopGroup', 'salesGroup', 'ordersGroup', 'labourGroup'];
  salesSummary: any;


  constructor(private ytdStoreReportService: YtdResultByStoreService, private router: Router, private snackBarService: SnackBarService,
  ) {
    const ytdStoreReportData = sessionStorage.getItem('ytdResultByStoreReportData');
    if (ytdStoreReportData) {
      this.requestData = JSON.parse(ytdStoreReportData);
      //  console.log('Request Data:', this.requestData);
    } else {
      console.log('Data not found in sessionStorage');
    }

  }


  ngOnInit(): void {
    this.ytdStoreReport(); // Call API function separately
  }



  ytdStoreReport(): void {
    if (this.requestData) {
      this.isLoading = true;
      this.ytdStoreReportService.getYtdNoViewList(this.requestData).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response && response.data && response.data.sales_list) {
            this.reportData = response.data.sales_list;
            this.labourDetails = response.data.labour_details;
            this.salesSummary = response.data.sales_summary;
            //  console.log('API Response:', this.reportData);
            this.calculateTotals();
          } else {
            console.warn('Unexpected API response structure:', response);
            this.reportData = [];
            this.labourDetails = {};
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error fetching data:', error);
        }
      });
    }
  }




  calculateTotals(): void {
    const totalSalesTY = this.reportData.reduce((sum, item) => sum + item.this_year_this_week_sales, 0);
    const totalSalesLY = this.reportData.reduce((sum, item) => sum + item.last_year_this_week_sales, 0);
    const totalOrdersTY = this.reportData.reduce((sum, item) => sum + item.this_week_cust_orders, 0);
    const totalOrdersLY = this.reportData.reduce((sum, item) => sum + item.last_year_cust_orders, 0);

    this.totals = {
      this_year_this_week_sales: totalSalesTY,
      last_year_this_week_sales: totalSalesLY,
      this_week_cust_orders: totalOrdersTY,
      last_year_cust_orders: totalOrdersLY,
      sales_var: totalSalesTY - totalSalesLY,
      orders_var: totalOrdersTY - totalOrdersLY,
      avg_sale_ty: totalOrdersTY ? totalSalesTY / totalOrdersTY : 0, // Fix
      avg_sale_ly: totalOrdersLY ? totalSalesLY / totalOrdersLY : 0, // Fix
      labour_percent_ty: this.reportData.reduce((sum, item) => sum + item.weekly_labour_per, 0) / this.reportData.length,
      labour_percent_ly: this.reportData.reduce((sum, item) => sum + item.last_year_this_week_labor_per, 0) / this.reportData.length,
      labour_percent_var: this.reportData.reduce((sum, item) => sum + (item.weekly_labour_per - item.last_year_this_week_labor_per), 0) / this.reportData.length
    };

    //  console.log("total", this.totals.this_year_this_week_sales);
  }



  exportClicked(): void {
    const exportPayload = JSON.parse(JSON.stringify(this.requestData));
    exportPayload.isExport = 1;

    if (exportPayload) {
      this.IsDownloading = true;

      this.ytdStoreReportService.getWeekNoExportList(exportPayload).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              }
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'ytd-report-by-store.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }


  //  getWeekEndingDate(year: number, weekNo: number): string {
  //    // Get the first day of the year
  //    let firstDayOfYear = new Date(year, 0, 1);

  //    // Find the first Thursday of the year (ISO-8601 week starts on Monday)
  //    let firstThursday = new Date(firstDayOfYear);
  //    firstThursday.setDate(firstThursday.getDate() + (4 - firstThursday.getDay()));

  //    // Calculate the start of the given week (weeks start on Monday)
  //    let startOfWeek = new Date(firstThursday);
  //    startOfWeek.setDate(startOfWeek.getDate() + (weekNo - 1) * 7 - 3);

  //    // Get the last day (Sunday) of the given week
  //    let endOfWeek = new Date(startOfWeek);
  //    endOfWeek.setDate(endOfWeek.getDate() + 6);

  //    // Format the date (YYYY-MM-DD)
  //    return endOfWeek.toISOString().split('T')[0];
  //  }
  getWeekEndingDate(financialYear: number, weekNo: number): string {
    // Financial Year starts on April 1st
    let financialYearStart = new Date(financialYear, 3, 1); // April 1st (month index 3 = April)

    // Get the day of the week for April 1st (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    let dayOfWeek = financialYearStart.getDay();

    // Calculate the first Sunday of the financial year
    let firstSunday = new Date(financialYearStart);
    if (dayOfWeek !== 0) {
      firstSunday.setDate(firstSunday.getDate() + (7 - dayOfWeek)); // Move to the first Sunday
    }

    // Calculate the week-ending Sunday for the given week number
    let endOfWeek = new Date(firstSunday);
    endOfWeek.setDate(endOfWeek.getDate() + (weekNo - 1) * 7);

    // Format the date in local timezone as YYYY-MM-DD
    const year = endOfWeek.getFullYear();
    const month = String(endOfWeek.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(endOfWeek.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  navBack(): void {

    this.router.navigate(['/report/ytd-result-by-store']);


  }

}
